import type { FC } from 'react';
import { useCallback, useEffect, useRef, useState } from 'react';

import type { CustomerCardRef } from '@makemydeal/dr-dash-components';
import { CustomerCard as DealCentralCustomerCard, VIEW_MODE } from '@makemydeal/dr-dash-components';
import type { CustomerCardProps } from '../../types/CustomerCard';
import { Accordion, AccordionSummary } from '@interstate/components/AccordionGroup';
import {
    StyledAccordionContainer,
    AccordionHeaderContent,
    StyledAccordionTitle,
    StyledAccordionHeader,
    StyledAccordionHeaderTitleContainer
} from '../Activity.style';
import { ExclamationCircleIcon } from '@interstate/components/Icons';
import { Typography } from '@interstate/components/Typography';
import { useSelector } from 'react-redux';
import { selectors } from '../../store';

export const CustomerCard: FC<CustomerCardProps> = ({ onCustomerCardValidationChange }: CustomerCardProps) => {
    const customerCardRef = useRef<CustomerCardRef>(null);
    const syncConsumerData = useSelector(selectors.getIsSyncConsumerData);
    const [isEditMode, setEditMode] = useState(false);

    const onCancel = () => {
        setEditMode(false);
    };

    const handleEditModeChange = () => {
        setEditMode(!isEditMode);
    };

    const onApply = (data: any) => {
        onCustomerCardValidationChange(true, data);
    };

    useEffect(() => {
        if (syncConsumerData && customerCardRef.current && customerCardRef.current.apply) {
            customerCardRef.current.apply();
        }
    }, [syncConsumerData]);

    const isCustomerDataValid = useCallback(
        (valid: boolean) => {
            onCustomerCardValidationChange(valid);
        },
        [onCustomerCardValidationChange]
    );

    return (
        <StyledAccordionContainer>
            <Accordion
                onChange={handleEditModeChange}
                expanded={isEditMode}
                className="custom-accordion"
                data-testid="vehicle-picker-accordion"
            >
                <AccordionSummary chevronPosition="right" className="custom-accordion-summary-hide-icon">
                    <StyledAccordionHeader>
                        <StyledAccordionTitle>
                            <StyledAccordionHeaderTitleContainer>
                                <ExclamationCircleIcon />
                                <Typography variant="h6">Customer</Typography>
                            </StyledAccordionHeaderTitleContainer>
                            <Typography className="editToggle" variant="h6">
                                {isEditMode ? 'Close' : 'Edit'}
                            </Typography>
                        </StyledAccordionTitle>
                        <AccordionHeaderContent onClick={(e) => e.stopPropagation()}>
                            <DealCentralCustomerCard
                                customer={'buyer'}
                                ref={customerCardRef}
                                hideApply={true}
                                hideCancel={true}
                                onApply={onApply}
                                onCancel={onCancel}
                                enableSpd={false}
                                onValidationChange={isCustomerDataValid}
                                viewMode={isEditMode ? VIEW_MODE.FULL : VIEW_MODE.COLLAPSED}
                            />
                        </AccordionHeaderContent>
                    </StyledAccordionHeader>
                </AccordionSummary>
            </Accordion>
        </StyledAccordionContainer>
    );
};
